import { RefObject, useEffect } from 'react';

export function useClickOutside(callback: () => void, refsToIgnore: RefObject<Element>[] | null = null) {
    const handleClick = (e: Event) => {
        if (
            !refsToIgnore?.reduce(
                (contains, next) => contains || (next.current?.contains(e.target as Node) ?? false),
                false,
            )
        ) {
            callback();
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClick);

        return () => {
            document.removeEventListener('click', handleClick);
        };
    });
}
